'use client'

import Cta from '@/components/cta/cta'

export default function Error({ error, reset }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[100svh] px-(--outer-gutter) text-center bg-main-light text-main-dark">
      <h1 className="font-serif font-[450] text-[5rem] leading-[115%] tracking-[-0.04em] lg:text-[8rem] mb-10 lg:mb-7.5">500</h1>
      <p className="body-1-small lg:body-1 mb-(--space-8) max-w-145 text-main-dark-800">
        {process.env.NODE_ENV === 'development' && (
          error.message
        )}
        {process.env.NODE_ENV !== 'development' && (
          'The server encountered an internal error and was unable to complete your request'
        )}
      </p>
      <Cta className="cta-big" onClick={() => reset()}>
        Try again
      </Cta>
    </div>
  )
}
